import React from 'react';
import { usePreloadedQuery, graphql, type PreloadedQuery } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import Tooltip from '@atlaskit/tooltip';
import type { viewBacklogCustomFiltersQuery } from '@atlassian/jira-relay/src/__generated__/viewBacklogCustomFiltersQuery.graphql';
import CustomFilterRelay from '@atlassian/jira-software-filters/src/ui/custom-filter/index.tsx';
import type { CustomFilterProps as CustomFilterRelayProps } from '@atlassian/jira-software-filters/src/ui/stateless/types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

type BacklogCustomFilterRelayProps = Flow.Diff<
	CustomFilterRelayProps,
	{
		customFiltersQueryRef?: PreloadedQuery<OperationType>;
	}
> & {
	customFiltersQueryRef: PreloadedQuery<viewBacklogCustomFiltersQuery>;
};

export const BacklogCustomFilterRelay = ({
	customFiltersQueryRef,
	...props
}: BacklogCustomFilterRelayProps) => {
	const { formatMessage } = useIntl();
	const customFiltersFragmentRef = usePreloadedQuery<viewBacklogCustomFiltersQuery>(
		graphql`
			query viewBacklogCustomFiltersQuery($boardId: ID!) {
				# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
				...customFilter_softwareFilters_CustomFilterRelay @arguments(boardId: $boardId)
			}
		`,
		customFiltersQueryRef,
	);

	if (props?.isTriggerDisabled && fg('tnk_disable_custom_filter_when_there_are_5k_issues')) {
		return (
			<Tooltip content={formatMessage(messages.hasReachedLimitLabel)}>
				<CustomFilterRelay
					customFiltersFragmentRef={customFiltersFragmentRef}
					{...props}
					isTriggerDisabled
				/>
			</Tooltip>
		);
	}

	return <CustomFilterRelay customFiltersFragmentRef={customFiltersFragmentRef} {...props} />;
};
